import gql from 'graphql-tag'
export default gql`mutation createAttestMutation($attest: BaseAttest!) {
  createAttest(attest: $attest) {
    attestNumber
    expirationDate
    id
  }
}`